import React from 'react'
import { Button } from '@conekta/frontino-ui/Button'
import { IRegistrationStepId } from '../../interface'
import { useSkip } from 'apps/Onboarding/views/BlueBook/hooks/useSkip'
import { useTranslation } from 'react-i18next'
import './DocumentsButtons.scss'

export const DocumentsButtons = ({
  hasKycProblem,
  hasValidationErrors,
  isLoading,
  pristine,
  submitting
}: IRegistrationStepId): JSX.Element => {
  const { t } = useTranslation()
  const { handleOnSkip } = useSkip()
  const btnSkip = t('command.skip')
  const btnText = !hasKycProblem ? t(`wizard.documents.uploadFilesButton`) : t(`wizard.documents.saveInformationButton`)

  return (
    <div className='documents-buttons'>
      <Button onClick={handleOnSkip()} className='documents-buttons__btn-skip' type='button' variant='secondary'>
        {btnSkip}
      </Button>
      <Button
        disabled={hasValidationErrors || isLoading || submitting || pristine}
        className='documents-buttons__btn-upload'
        loading={isLoading}
        variant='primary'
        type='submit'
      >
        {btnText}
      </Button>
    </div>
  )
}
